export default "__VITE_ASSET__CClJxnaj__"